import { AnalysisType } from "@/types/analysis/ProjectAnalysis";
import { CadModelCategory } from "@api/apiClient";

/**
 * Common utility for handling viewer isolation based on attribute type
 */
export const isolateViewersByAttribute = async (
  groupKey: string | undefined,
  attributeType: AnalysisType,
  cadModelCategories: { data?: CadModelCategory[] | undefined; },
  appStore: any
): Promise<void> => {

  if (groupKey) {
    // Handle different attribute types for viewer isolation
    switch (attributeType) {
      case AnalysisType.System:
        await appStore.lmViewer1?.isolateBySystem(groupKey);
        await appStore.lmViewer2?.isolateBySystem(groupKey);
        break;
      case AnalysisType.SubSystem:
        await appStore.lmViewer1?.isolateBySubSystem(groupKey);
        await appStore.lmViewer2?.isolateBySubSystem(groupKey);
        break;
      case AnalysisType.Attribute1:
        await appStore.lmViewer1?.isolateByAttributeValue("freeText1", groupKey);
        await appStore.lmViewer2?.isolateByAttributeValue("freeText1", groupKey);
        break;
      case AnalysisType.Attribute2:
        await appStore.lmViewer1?.isolateByAttributeValue("freeText2", groupKey);
        await appStore.lmViewer2?.isolateByAttributeValue("freeText2", groupKey);
        break;
      case AnalysisType.Attribute3:
        await appStore.lmViewer1?.isolateByAttributeValue("freeText3", groupKey);
        await appStore.lmViewer2?.isolateByAttributeValue("freeText3", groupKey);
        break;
      default:
        // Fallback to model category for backward compatibility
        const cadModelCategory = cadModelCategories.data?.find((cmc: CadModelCategory) => cmc.label === groupKey);
        await appStore.lmViewer1?.isolateByModelCategoryId(cadModelCategory?.value);
        await appStore.lmViewer2?.isolateByModelCategoryId(cadModelCategory?.value);
        break;
    }
  } else {
    await appStore.lmViewer1?.resetView();
    await appStore.lmViewer2?.resetView();
  }
};
